/**
 * Quick-add modal: alt-based gallery + color/size selection.
 * Media matching mirrors PDP / product-card alt-gallery rules.
 */
(function () {
  if (window.__quickAddModalUiBound) return;
  window.__quickAddModalUiBound = true;

  function moneySuffix(currency) {
    return currency ? ' ' + currency : '';
  }

  function mediaMatchesVariant(media, variant, data) {
    var alt = (media.alt || '').toLowerCase().trim();
    var variantId = String(variant.id || '');

    if (alt && variantId) {
      if (alt === variantId) return true;
      var dashParts = alt.split('-');
      var underParts = alt.split('_');
      if (dashParts.indexOf(variantId) !== -1 || underParts.indexOf(variantId) !== -1) {
        return true;
      }
    }

    if (data.useAltGalleryTag) {
      return false;
    }

    if (data.hasColorCoded || data.hasColorCodedAlts) {
      var colorPos = data.colorOptionPosition;
      var color = '';
      if (colorPos === 1) color = (variant.option1 || '').toLowerCase().trim();
      else if (colorPos === 2) color = (variant.option2 || '').toLowerCase().trim();
      else if (colorPos === 3) color = (variant.option3 || '').toLowerCase().trim();
      return Boolean(color && alt.indexOf(color) !== -1);
    }

    return true;
  }

  function longestColorInAlt(alt, colorValues) {
    var text = String(alt || '').toLowerCase();
    var colors = (colorValues || []).slice().sort(function (a, b) {
      return String(b).length - String(a).length;
    });
    for (var i = 0; i < colors.length; i++) {
      var token = String(colors[i] || '')
        .toLowerCase()
        .trim();
      if (token && text.indexOf(token) !== -1) return token;
    }
    return '';
  }

  function optionColorForVariant(variant, colorPos) {
    if (colorPos === 1) return (variant.option1 || '').toLowerCase().trim();
    if (colorPos === 2) return (variant.option2 || '').toLowerCase().trim();
    if (colorPos === 3) return (variant.option3 || '').toLowerCase().trim();
    return '';
  }

  /* Resolve media → color via alt color name OR variant-id tokens in alt (Ava PDP). */
  function colorOfMedia(media, data) {
    var fromAlt = longestColorInAlt(media.alt, data.colorValues);
    if (fromAlt) return fromAlt;
    var alt = String(media.alt || '')
      .toLowerCase()
      .trim();
    if (!alt || !data.colorOptionPosition) return '';
    var tokens = alt.split(/[-_]/);
    var variants = data.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var vid = String(variants[i].id || '');
      if (vid && tokens.indexOf(vid) !== -1) {
        return optionColorForVariant(variants[i], data.colorOptionPosition);
      }
    }
    return '';
  }

  /* Bare numeric alts are Shopify variant-featured heroes (e.g. Tia 21_9eda).
     PDP c-product swiper jumps past them to the size packshot; exclude from QV. */
  function isNumericAltHero(media) {
    return /^\d+$/.test(String((media && media.alt) || '').trim());
  }

  function colorBlockForVariant(variant, data) {
    var list = data.media || [];
    if (!list.length) return [];
    var useBlocks = data.hasColorCodedAlts || data.hasColorCoded;
    if (!useBlocks || !data.colorOptionPosition) return list.slice();

    var selectedColor = optionColorForVariant(variant, data.colorOptionPosition);
    if (!selectedColor) return list.slice();

    var selectedStart = -1;
    for (var i = 0; i < list.length; i++) {
      if (colorOfMedia(list[i], data) === selectedColor) {
        selectedStart = i;
        break;
      }
    }

    /* No color-name hit → keep full media (PDP main-product-ava-redesign parity). */
    if (selectedStart < 0) return list.slice();

    var nextStart = list.length;
    for (var j = selectedStart + 1; j < list.length; j++) {
      var nextColor = colorOfMedia(list[j], data);
      if (nextColor && nextColor !== selectedColor) {
        nextStart = j;
        break;
      }
    }

    /*
     * Walk backward from the first color-named packshot through untagged media
     * (numeric heroes, 4P packshots with incomplete alts, lifestyles). Stop at
     * the previous color. Fixes Tia Silver where 4P is `11.webp` with a shared
     * alt and color names only appear on 8/12/16 packshots.
     */
    var blockStart = selectedStart;
    for (var k = selectedStart - 1; k >= 0; k--) {
      var prevColor = colorOfMedia(list[k], data);
      if (prevColor && prevColor !== selectedColor) break;
      blockStart = k;
    }

    return list.slice(blockStart, nextStart).filter(function (media) {
      return !isNumericAltHero(media);
    });
  }

  /* Score media by how many selected option values appear in alt.
     Size+color packshots (e.g. "Matte Gold-4 Person Set") beat color-only / lifestyle. */
  function mediaOptionScore(media, variant) {
    if (!media || !variant) return 0;
    var alt = String(media.alt || '').toLowerCase();
    if (!alt) return 0;
    var score = 0;
    for (var p = 1; p <= 3; p++) {
      var val = normalizeOption(optionValue(variant, p)).toLowerCase();
      if (val && alt.indexOf(val) !== -1) score += 1;
    }
    return score;
  }

  function bestOptionMediaIndex(variant, list) {
    if (!variant || !list || !list.length) return -1;
    var optionCount = 0;
    for (var p = 1; p <= 3; p++) {
      if (normalizeOption(optionValue(variant, p))) optionCount += 1;
    }
    var minScore = Math.min(2, optionCount);
    if (minScore < 1) return -1;

    var bestIdx = -1;
    var bestScore = 0;
    for (var i = 0; i < list.length; i++) {
      var score = mediaOptionScore(list[i], variant);
      if (score > bestScore) {
        bestScore = score;
        bestIdx = i;
      }
    }
    return bestScore >= minScore ? bestIdx : -1;
  }

  function optionValue(variant, position) {
    var pos = Number(position);
    if (pos === 1) return variant.option1 || '';
    if (pos === 2) return variant.option2 || '';
    if (pos === 3) return variant.option3 || '';
    return '';
  }

  function normalizeOption(value) {
    return String(value == null ? '' : value)
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function optionsMatch(a, b) {
    var left = normalizeOption(a);
    var right = normalizeOption(b);
    if (!left || !right) return left === right;
    return left === right || left.toLowerCase() === right.toLowerCase();
  }

  function formatMoneyCents(cents, currency) {
    var amount = Number(cents || 0) / 100;
    var formatted = amount % 1 === 0 ? String(amount) : amount.toFixed(2).replace(/\.?0+$/, '');
    return '$' + formatted + moneySuffix(currency);
  }

  function initModal(root) {
    if (!root || root.getAttribute('data-qa-ready') === 'true') return;
    root.setAttribute('data-qa-ready', 'true');

    var jsonEl = root.querySelector('[data-qa-json]');
    if (!jsonEl) return;

    var data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var track = root.querySelector('[data-qa-track]');
    var viewport = root.querySelector('[data-qa-viewport]') || root.querySelector('.quick-add-modal__viewport');
    var thumbsWrap = root.querySelector('[data-qa-thumbs-wrap]');
    var thumbs = root.querySelector('[data-qa-thumbs]');
    var thumbsPrevBtn = root.querySelector('[data-qa-thumbs-prev]');
    var thumbsNextBtn = root.querySelector('[data-qa-thumbs-next]');
    var dots = root.querySelector('[data-qa-dots]');
    var nav = root.querySelector('[data-qa-nav]');
    var prevBtn = root.querySelector('[data-qa-prev]');
    var nextBtn = root.querySelector('[data-qa-next]');
    var variantInput = root.querySelector('[data-qa-variant-id]');
    var submitBtn = root.querySelector('[data-qa-submit]');
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-qa-swatch]'));
    var sizeContainers = Array.prototype.slice.call(root.querySelectorAll('[data-qa-sizes]'));
    var main = root.querySelector('[data-qa-main]');
    var gallerySwiper = null;
    var THUMB_STEP = 157;
    var optionMetas = data.optionMetas || [];
    var buttonMetas = optionMetas.filter(function (m) { return m.ui === 'button'; });
    var hasButtonOptions = buttonMetas.length > 0 && sizeContainers.length > 0;

    function getThumbStep() {
      if (!thumbs) return THUMB_STEP;
      var thumb = thumbs.querySelector('.quick-add-modal__thumb');
      if (!thumb) return THUMB_STEP;
      var styles = window.getComputedStyle(thumbs);
      var gap = parseFloat(styles.rowGap || styles.gap) || 15;
      return thumb.offsetHeight + gap;
    }

    var selected = {};
    optionMetas.forEach(function (meta) {
      selected[meta.position] = '';
    });
    if (data.colorOptionPosition && data.defaultColor) {
      selected[data.colorOptionPosition] = data.defaultColor;
    }
    var currentSlide = 0;
    var visibleMedia = [];
    var galleryScrollLock = false;
    var galleryFeaturedTarget = 0;
    var galleryGoToken = 0;

    function findVariantById(id) {
      if (!id) return null;
      var idStr = String(id);
      for (var i = 0; i < data.variants.length; i += 1) {
        if (String(data.variants[i].id) === idStr) return data.variants[i];
      }
      return null;
    }

    function findVariant(sel, requireAllButtons) {
      var match = null;
      data.variants.forEach(function (variant) {
        var ok = optionMetas.every(function (meta) {
          var want = sel[meta.position];
          if (want == null || want === '') {
            if (requireAllButtons && meta.ui === 'button') return false;
            return true;
          }
          return optionsMatch(optionValue(variant, meta.position), want);
        });
        if (!ok) return;

        if (!match) {
          match = variant;
          return;
        }
        if (variant.available && !match.available) {
          match = variant;
          return;
        }
        if (variant.available === match.available && Number(variant.price) < Number(match.price)) {
          match = variant;
        }
      });
      return match;
    }

    function resolveVariant(sel) {
      return (
        findVariant(sel, true) ||
        findVariant(sel, false) ||
        findVariantById(data.defaultVariantId) ||
        data.variants[0] ||
        null
      );
    }

    function galleryMediaForVariant(variant) {
      if (!variant) return data.media.slice();

      function withMediaFirst(list, media) {
        var matched = (list || []).slice();
        if (!media || !matched.length) return matched;
        var id = String(media.id);
        return [media].concat(
          matched.filter(function (m) {
            return String(m.id) !== id;
          })
        );
      }

      function withFeaturedFirst(list) {
        if (!variant.featured_media_id || !list || !list.length) return (list || []).slice();
        var featuredId = String(variant.featured_media_id);
        var featured = list.find(function (m) {
          return String(m.id) === featuredId;
        });
        if (!featured) {
          featured = (data.media || []).find(function (m) {
            return String(m.id) === featuredId;
          });
        }
        /* Never lead with numeric-alt heroes — PDP shows the size packshot instead */
        if (!featured || isNumericAltHero(featured)) return (list || []).slice();
        return withMediaFirst(list, featured);
      }

      function withBestPackshotFirst(list) {
        var matched = (list || []).slice();
        var bestIdx = bestOptionMediaIndex(variant, matched);
        if (bestIdx > 0) return withMediaFirst(matched, matched[bestIdx]);
        if (bestIdx === 0) return matched;
        return withFeaturedFirst(matched);
      }

      /* alt-gallery tag products: variant-id alts only, featured first */
      if (data.useAltGalleryTag) {
        var idMatched = data.media.filter(function (media) {
          return mediaMatchesVariant(media, variant, data);
        });
        if (!idMatched.length) idMatched = data.media.slice(0, 8);
        return withFeaturedFirst(idMatched);
      }

      /*
       * Color-coded flatware (Tia, Ava, etc.): same color block as Ava PDP,
       * skip numeric-alt Shopify heroes, lead with the size+color packshot
       * that the live PDP shows for the selected variant.
       */
      if (data.hasColorCoded || data.hasColorCodedAlts) {
        var block = colorBlockForVariant(variant, data);
        if (!block.length) block = (data.media || []).slice().filter(function (m) {
          return !isNumericAltHero(m);
        });
        return withBestPackshotFirst(block.length ? block : data.media.slice(0, 8));
      }

      /* Non-coded products: natural media order; caller scrolls to featured */
      var matched = (data.media || []).slice();
      return matched.length ? matched : data.media.slice(0, 8);
    }

    function featuredMediaIndex(variant, list) {
      if (!variant || !list || !list.length) return 0;
      var bestIdx = bestOptionMediaIndex(variant, list);
      if (bestIdx >= 0) return bestIdx;
      var featuredId = variant.featured_media_id != null ? String(variant.featured_media_id) : '';
      if (featuredId) {
        for (var i = 0; i < list.length; i++) {
          if (String(list[i].id) === featuredId && !isNumericAltHero(list[i])) return i;
        }
      }
      return 0;
    }

    /* Scroll main gallery + thumbs to the variant featured slide (PDP parity).
       Retries when the modal isn’t laid out yet (clientWidth === 0). */
    function goToFeaturedSlide(attempt) {
      var tries = typeof attempt === 'number' ? attempt : 0;
      if (!viewport || !visibleMedia.length) return;
      var token = galleryGoToken;
      currentSlide = galleryFeaturedTarget;
      galleryScrollLock = true;
      syncMainWidthFromImage();
      sizeGallerySlides();
      var w = getViewportWidth();
      if (!w) {
        if (tries < 24 && token === galleryGoToken) {
          requestAnimationFrame(function () {
            if (token === galleryGoToken) goToFeaturedSlide(tries + 1);
          });
          if (tries === 0 || tries === 4 || tries === 8 || tries === 12) {
            setTimeout(function () {
              if (token === galleryGoToken) goToFeaturedSlide(tries + 1);
            }, 40 + tries * 25);
          }
        }
        return;
      }
      viewport.style.scrollBehavior = 'auto';
      viewport.scrollLeft = currentSlide * w;
      /* Re-assert after layout/paint — some browsers reset scrollLeft on flex width apply */
      if (Math.abs(viewport.scrollLeft - currentSlide * w) > 2 && tries < 24) {
        requestAnimationFrame(function () {
          if (token === galleryGoToken) goToFeaturedSlide(tries + 1);
        });
        return;
      }
      updateGalleryChrome(true);
      /* Hold the lock briefly so late scroll/size events can’t snap back to slide 0 */
      setTimeout(function () {
        if (token !== galleryGoToken) return;
        if (viewport && visibleMedia.length) {
          var ww = getViewportWidth();
          if (ww) viewport.scrollLeft = galleryFeaturedTarget * ww;
          currentSlide = galleryFeaturedTarget;
          updateGalleryChrome(true);
        }
        galleryScrollLock = false;
      }, 180);
      /* Instant thumb jump on variant change (smooth only for arrow nav) */
      if (thumbs) {
        var active = thumbs.querySelector('.quick-add-modal__thumb.is-active');
        if (active) {
          var thumbTop = active.offsetTop;
          var thumbBottom = thumbTop + active.offsetHeight;
          var viewTop = thumbs.scrollTop;
          var viewBottom = viewTop + thumbs.clientHeight;
          if (thumbTop < viewTop || thumbBottom > viewBottom) {
            thumbs.scrollTop = Math.max(0, thumbTop - Math.max(0, (thumbs.clientHeight - active.offsetHeight) / 2));
          }
        }
      }
    }

    function currentQty() {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      return n;
    }

    function setPrices(variant) {
      if (!variant) return;

      var qty = currentQty();
      var unitPrice = Number(variant.price) || 0;
      var unitCompare = Number(variant.compare) || 0;
      var totalPrice = unitPrice * qty;
      var totalCompare = unitCompare * qty;

      var priceText = formatMoneyCents(totalPrice, data.currency);
      var compareText = '';
      var saveText = '';

      if (unitCompare > unitPrice) {
        compareText = formatMoneyCents(totalCompare, data.currency);
        saveText = formatMoneyCents(totalCompare - totalPrice, data.currency)
          .replace(moneySuffix(data.currency), '')
          .trim();
      }

      Array.prototype.forEach.call(root.querySelectorAll('[data-qa-price]'), function (el) {
        el.textContent = priceText;
      });

      Array.prototype.forEach.call(root.querySelectorAll('[data-qa-compare]'), function (el) {
        if (compareText) {
          el.textContent = compareText;
          el.removeAttribute('hidden');
          el.hidden = false;
        } else {
          el.textContent = '';
          el.setAttribute('hidden', '');
          el.hidden = true;
        }
      });

      Array.prototype.forEach.call(root.querySelectorAll('[data-qa-save]'), function (el) {
        if (saveText) {
          el.textContent = 'Save ' + saveText;
          el.removeAttribute('hidden');
          el.hidden = false;
        } else {
          el.textContent = '';
          el.setAttribute('hidden', '');
          el.hidden = true;
        }
      });
    }

    function setSubmit(variant) {
      if (!variantInput || !submitBtn) return;
      // Always clear a leftover ATC spinner when the button label is refreshed.
      submitBtn.classList.remove('is-loading');
      submitBtn.removeAttribute('aria-busy');
      submitBtn.removeAttribute('data-qa-label');
      variantInput.value = variant ? String(variant.id) : '';
      var onByob = Boolean(document.querySelector('[data-byob-builder]'));
      var addLabel = onByob ? 'Add to Bundle' : 'Add To Cart';
      if (variant && variant.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = addLabel;
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sold Out';
      }
    }

    function notifyCartAdded(payload) {
      var item = payload;
      if (payload && payload.items && payload.items.length) {
        item = payload.items[0];
      }

      if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
        try {
          window.Shopify.onItemAdded(item || payload);
        } catch (e) {}
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { openDrawer: true }
        })
      );
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: payload }));

      if (typeof window.showCornerCartModal === 'function') {
        try {
          window.showCornerCartModal();
        } catch (e) {}
      }
    }

    function addToCartAjax(form) {
      var formData = new FormData(form);
      var id = formData.get('id');
      if (!id) return Promise.reject(new Error('Missing variant'));

      // Read qty from the visible stepper (not only FormData) so +/- always wins.
      var qtyEl =
        (form && form.querySelector('[data-qa-qty-input]')) ||
        (root && root.querySelector('[data-qa-qty-input]'));
      var quantity = parseInt(qtyEl && qtyEl.value, 10);
      if (isNaN(quantity) || quantity < 1) {
        quantity = parseInt(formData.get('quantity'), 10);
      }
      if (isNaN(quantity) || quantity < 1) quantity = 1;
      if (quantity > 99) quantity = 99;

      var payload = {
        items: [{ id: Number(id), quantity: quantity }]
      };

      return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/') + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            var message =
              (data && (data.description || data.message)) ||
              'Could not add to cart';
            throw new Error(message);
          }
          return data;
        });
      });
    }

    function closeThisModal(onDone) {
      setSubmitLoading(false);
      if (typeof window.closeQuickAddModal === 'function') {
        window.closeQuickAddModal(root, onDone);
        return;
      }
      if (!root.classList.contains('is-open')) {
        if (typeof onDone === 'function') onDone();
        return;
      }
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      if (window.ThemeOverlay) window.ThemeOverlay.hide('quick-add');
      if (typeof onDone === 'function') onDone();
    }

    function openCartAfterAdd() {
      if (document.querySelector('[data-byob-builder]')) return;
      if (window.FreshCartDrawer && typeof window.FreshCartDrawer.open === 'function') {
        window.FreshCartDrawer.open();
        return;
      }
      if (typeof window.JazzOpenCartDrawer === 'function') {
        window.JazzOpenCartDrawer();
      }
    }

    function setSubmitLoading(isLoading, fallbackLabel) {
      if (!submitBtn) return;
      if (isLoading) {
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');
        submitBtn.setAttribute('aria-busy', 'true');
        if (!submitBtn.getAttribute('data-qa-label')) {
          submitBtn.setAttribute('data-qa-label', submitBtn.textContent || fallbackLabel || 'Add To Cart');
        }
        submitBtn.textContent = submitBtn.getAttribute('data-qa-label') || fallbackLabel || 'Add To Cart';
        return;
      }
      submitBtn.classList.remove('is-loading');
      submitBtn.removeAttribute('aria-busy');
      var label = submitBtn.getAttribute('data-qa-label') || fallbackLabel || 'Add To Cart';
      submitBtn.removeAttribute('data-qa-label');
      submitBtn.disabled = false;
      submitBtn.textContent = label;
    }

    var form = root.querySelector('[data-qa-form]');
    var qaAddInflight = false;

    function claimQuickAddLock(formEl) {
      var idInput = formEl && formEl.querySelector('[name="id"]');
      var qtyEl = formEl && formEl.querySelector('[data-qa-qty-input], input[name="quantity"]');
      var id = idInput && idInput.value;
      var qty = parseInt(qtyEl && qtyEl.value, 10) || 1;
      var key = String(id) + ':' + String(qty);
      var now = Date.now();
      if (!window.__qaAddLock) window.__qaAddLock = { key: '', at: 0 };
      // Block duplicate adds from Candy Rack + form handler within a short window.
      if (window.__qaAddLock.key === key && now - window.__qaAddLock.at < 1800) {
        return false;
      }
      window.__qaAddLock.key = key;
      window.__qaAddLock.at = now;
      return true;
    }

    function runQuickAddFromForm() {
      if (!form || !submitBtn) return;
      if (submitBtn.disabled || submitBtn.classList.contains('is-loading') || qaAddInflight) return;
      if (!claimQuickAddLock(form)) return;

      qaAddInflight = true;
      var previousLabel = submitBtn.textContent || 'Add To Cart';
      setSubmitLoading(true, previousLabel);

      addToCartAjax(form)
        .then(function (data) {
          notifyCartAdded(data);
          if (typeof window.__setQuickAddReopenCart === 'function') {
            window.__setQuickAddReopenCart(false);
          }
          setSubmitLoading(false, previousLabel);
          qaAddInflight = false;
          closeThisModal(function () {
            openCartAfterAdd();
          });
        })
        .catch(function (err) {
          qaAddInflight = false;
          // Allow a real retry after a failed add.
          if (window.__qaAddLock) window.__qaAddLock.at = 0;
          setSubmitLoading(false, previousLabel);
          window.alert((err && err.message) || 'Could not add to cart');
        });
    }

    if (form && !form.getAttribute('data-qa-submit-bound')) {
      form.setAttribute('data-qa-submit-bound', 'true');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        runQuickAddFromForm();
      });
      // Candy Rack swallows submit clicks — listen for the bridge handoff.
      form.addEventListener('qa:force-add', function (event) {
        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        runQuickAddFromForm();
      });
    }

    if (submitBtn && !submitBtn.getAttribute('data-qa-click-bound')) {
      submitBtn.setAttribute('data-qa-click-bound', 'true');
      submitBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        runQuickAddFromForm();
      });
    }

    var qtyRoot = root.querySelector('[data-qa-qty]');
    var qtyInput = root.querySelector('[data-qa-qty-input]');
    var qtyMinus = root.querySelector('[data-qa-qty-minus]');
    var qtyPlus = root.querySelector('[data-qa-qty-plus]');
    var QTY_MIN = 1;
    var QTY_MAX = 99;
    var activeVariant = null;

    function clampQty(value) {
      var n = parseInt(value, 10);
      if (isNaN(n) || n < QTY_MIN) n = QTY_MIN;
      if (n > QTY_MAX) n = QTY_MAX;
      return n;
    }

    function syncQtyUi() {
      if (!qtyInput) return;
      var n = clampQty(qtyInput.value);
      qtyInput.value = String(n);
      if (qtyMinus) qtyMinus.disabled = n <= QTY_MIN;
      if (qtyPlus) qtyPlus.disabled = n >= QTY_MAX;
      if (activeVariant) setPrices(activeVariant);
    }

    if (qtyRoot && qtyInput && !qtyRoot.getAttribute('data-qa-qty-bound')) {
      qtyRoot.setAttribute('data-qa-qty-bound', 'true');
      syncQtyUi();

      if (qtyMinus) {
        qtyMinus.addEventListener('click', function () {
          qtyInput.value = String(clampQty(parseInt(qtyInput.value, 10) - 1));
          syncQtyUi();
        });
      }
      if (qtyPlus) {
        qtyPlus.addEventListener('click', function () {
          qtyInput.value = String(clampQty(parseInt(qtyInput.value, 10) + 1));
          syncQtyUi();
        });
      }
      qtyInput.addEventListener('change', syncQtyUi);
      qtyInput.addEventListener('blur', syncQtyUi);
      qtyInput.addEventListener('input', syncQtyUi);
    }

    function applyVariant(variant, options) {
      var opts = options || {};
      activeVariant = variant || null;
      setPrices(variant);
      setSubmit(variant);
      syncWhatsIncluded(variant);
      if (opts.skipGallery) return;
      renderGallery(variant);
    }

    var whatsWrap = root.querySelector('[data-qa-whats-wrap]');
    var whatsToggle = root.querySelector('[data-qa-whats-included-open]');
    var whatsDrop = root.querySelector('[data-qa-whats-drop]');
    var whatsBody = root.querySelector('[data-qa-whats-body]');
    var whatsMap = root.querySelector('[data-qa-whats-map]');

    function syncWhatsIncluded(variant) {
      if (!whatsBody || !whatsMap || !variant) return;
      var source = whatsMap.querySelector('[data-variant-id="' + variant.id + '"]');
      whatsBody.innerHTML = source
        ? source.innerHTML
        : '<p>Select a set to see what\'s included.</p>';
    }

    function whatsIsOpen() {
      return !!whatsDrop && !whatsDrop.hidden;
    }

    function openWhatsIncluded() {
      if (!whatsDrop) return;
      var variant = resolveVariant(selected);
      if (variant) syncWhatsIncluded(variant);
      whatsDrop.hidden = false;
      if (whatsWrap) whatsWrap.classList.add('is-open');
      if (whatsToggle) whatsToggle.setAttribute('aria-expanded', 'true');
      placeWhatsIncluded();
    }

    // The details column scrolls, so flip the panel above the link when it would
    // otherwise open past the bottom edge.
    function placeWhatsIncluded() {
      if (!whatsDrop || !whatsWrap) return;
      whatsDrop.classList.remove('is-up');
      var scroller = root.querySelector('.quick-add-modal__details') || whatsWrap.parentElement;
      if (!scroller) return;
      var bounds = scroller.getBoundingClientRect();
      var drop = whatsDrop.getBoundingClientRect();
      var anchor = whatsWrap.getBoundingClientRect();
      var spaceAbove = anchor.top - bounds.top;
      if (drop.bottom > bounds.bottom && spaceAbove > drop.height + 10) {
        whatsDrop.classList.add('is-up');
      }
    }

    function closeWhatsIncluded() {
      if (!whatsDrop) return;
      whatsDrop.hidden = true;
      if (whatsWrap) whatsWrap.classList.remove('is-open');
      if (whatsToggle) whatsToggle.setAttribute('aria-expanded', 'false');
    }

    if (whatsToggle) {
      whatsToggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (whatsIsOpen()) closeWhatsIncluded();
        else openWhatsIncluded();
      });
    }

    document.addEventListener('click', function (event) {
      if (!whatsIsOpen()) return;
      if (whatsWrap && whatsWrap.contains(event.target)) return;
      closeWhatsIncluded();
    });

    if (whatsDrop && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        if (!root.classList.contains('is-open')) closeWhatsIncluded();
      }).observe(root, { attributes: true, attributeFilter: ['class'] });
    }

    // Capture phase so Escape dismisses the dropdown without also closing quick view.
    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Escape' || !whatsIsOpen()) return;
        event.stopPropagation();
        closeWhatsIncluded();
        if (whatsToggle) whatsToggle.focus();
      },
      true
    );

    function updateOptionNameLabels() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-qa-option]'), function (field) {
        var pos = Number(field.getAttribute('data-option-position'));
        var nameEl = field.querySelector('[data-qa-option-name]');
        if (nameEl && selected[pos]) nameEl.textContent = selected[pos];
      });
    }

    function buildSizeButton(sizeValue, variant, position) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'quick-add-modal__size';
      if (!variant || !variant.available) {
        btn.classList.add('is-unavailable');
      }
      btn.setAttribute('data-qa-size', sizeValue);
      btn.setAttribute('data-option-position', String(position));
      if (variant) btn.setAttribute('data-variant-id', String(variant.id));
      btn.setAttribute('aria-pressed', 'false');

      var check = document.createElement('span');
      check.className = 'quick-add-modal__size-check';
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML =
        '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9.5" fill="#050d37"/><path d="M5.5 10.2L8.4 13.1L14.5 7" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.appendChild(check);

      var label = document.createElement('span');
      label.className = 'quick-add-modal__size-label';
      label.textContent = sizeValue;
      btn.appendChild(label);

      if (variant && variant.badge) {
        var badge = document.createElement('span');
        var badgeLabel = String(variant.badge);
        var badgeLower = badgeLabel.toLowerCase();
        badge.className = 'quick-add-modal__size-badge';
        if (/best\s*(value|deal)/.test(badgeLower)) {
          badge.classList.add('quick-add-modal__size-badge--alt');
        }
        badge.textContent = badgeLabel;
        btn.appendChild(badge);
      }

      if (variant && variant.saveDisplay) {
        var save = document.createElement('span');
        save.className = 'quick-add-modal__save-badge';
        save.textContent = 'Save ' + variant.saveDisplay;
        btn.appendChild(save);
      } else if (variant && Number(variant.compare) > Number(variant.price)) {
        var saveFallback = document.createElement('span');
        saveFallback.className = 'quick-add-modal__save-badge';
        saveFallback.textContent =
          'Save ' +
          formatMoneyCents(Number(variant.compare) - Number(variant.price), data.currency).replace(
            moneySuffix(data.currency),
            ''
          ).trim();
        btn.appendChild(saveFallback);
      }

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        selectButtonValue(position, sizeValue, variant ? String(variant.id) : '');
      });

      return btn;
    }

    function renderButtonOptions() {
      if (!hasButtonOptions) {
        applyVariant(resolveVariant(selected));
        return;
      }

      buttonMetas.forEach(function (meta) {
        var container = root.querySelector(
          '[data-qa-sizes][data-option-position="' + meta.position + '"]'
        );
        if (!container) return;
        container.innerHTML = '';

        var firstAvailable = '';
        var firstValue = '';

        (meta.values || []).forEach(function (sizeValue) {
          var probe = Object.assign({}, selected);
          probe[meta.position] = sizeValue;
          var variant = findVariant(probe, false);
          container.appendChild(buildSizeButton(sizeValue, variant, meta.position));
          if (!firstValue && variant) firstValue = sizeValue;
          if (!firstAvailable && variant && variant.available) firstAvailable = sizeValue;
        });

        if (!selected[meta.position] || !findVariant(Object.assign({}, selected), false)) {
          selected[meta.position] = firstAvailable || firstValue || '';
        }
      });

      syncButtonSelection();
      applyVariant(resolveVariant(selected));
    }

    function syncButtonSelection() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-qa-size]'), function (btn) {
        var pos = Number(btn.getAttribute('data-option-position'));
        var on = optionsMatch(btn.getAttribute('data-qa-size'), selected[pos]);
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function selectButtonValue(position, value, variantId) {
      selected[position] = value || '';
      syncButtonSelection();
      var variant = findVariantById(variantId) || resolveVariant(selected);
      applyVariant(variant);
    }

    function updateThumbsNav() {
      if (!thumbs || !thumbsPrevBtn || !thumbsNextBtn) return;

      var count = thumbs.querySelectorAll('.quick-add-modal__thumb').length;
      var needsNav = count > 1;
      if (thumbsWrap) {
        thumbsWrap.classList.toggle('has-nav', needsNav);
        thumbsWrap.classList.toggle('has-overflow', needsNav);
      }
      thumbsPrevBtn.classList.toggle('is-hidden', !needsNav);
      thumbsNextBtn.classList.toggle('is-hidden', !needsNav);
      if (!needsNav) {
        thumbsPrevBtn.disabled = true;
        thumbsNextBtn.disabled = true;
        return;
      }

      var overflow = thumbs.scrollHeight > thumbs.clientHeight + 2;
      if (!overflow) {
        thumbsPrevBtn.disabled = currentSlide <= 0;
        thumbsNextBtn.disabled = currentSlide >= count - 1;
        return;
      }

      var maxScroll = thumbs.scrollHeight - thumbs.clientHeight;
      thumbsPrevBtn.disabled = thumbs.scrollTop <= 2;
      thumbsNextBtn.disabled = thumbs.scrollTop >= maxScroll - 2;
    }

    function scrollThumbsBy(direction) {
      if (!thumbs) return;
      var overflow = thumbs.scrollHeight > thumbs.clientHeight + 2;
      if (overflow) {
        thumbs.scrollBy({ top: direction * getThumbStep(), behavior: 'smooth' });
        return;
      }
      showSlide(currentSlide + direction);
    }

    function scrollActiveThumbIntoView() {
      if (!thumbs) return;
      var active = thumbs.querySelector('.quick-add-modal__thumb.is-active');
      if (!active) return;
      var thumbTop = active.offsetTop;
      var thumbBottom = thumbTop + active.offsetHeight;
      var viewTop = thumbs.scrollTop;
      var viewBottom = viewTop + thumbs.clientHeight;
      if (thumbTop < viewTop) {
        thumbs.scrollTo({ top: thumbTop, behavior: 'smooth' });
      } else if (thumbBottom > viewBottom) {
        thumbs.scrollTo({ top: thumbBottom - thumbs.clientHeight, behavior: 'smooth' });
      }
    }

    function syncMainWidthFromImage() {
      if (!main) return;
      var dialog = root.querySelector('.quick-add-modal__dialog') || root;
      var galleryH = main.clientHeight || parseFloat(getComputedStyle(dialog).getPropertyValue('--qa-gallery-h')) || 635;
      if (!galleryH || galleryH < 1) galleryH = 635;
      /* Wider than original Figma 552 so cover doesn’t clip pack-shot side badges.
         Prefer that width (or whatever room remains) — do not shrink to the
         image’s natural aspect (that left empty side gutters with contain). */
      var figW = Math.round(galleryH * (640 / 635));
      var detailsMin = parseFloat(getComputedStyle(dialog).getPropertyValue('--qa-details-min')) || 360;
      var thumbW = parseFloat(getComputedStyle(dialog).getPropertyValue('--qa-thumb-w')) || 125;
      var dialogInner = Math.min(dialog.clientWidth || window.innerWidth * 0.92, window.innerWidth * 0.92) - 64;
      var room = Math.max(280, dialogInner - 30 - thumbW - 16 - detailsMin);
      var w = Math.min(Math.max(figW, 420), room, 720);
      if (room < figW) w = room;
      dialog.style.setProperty('--qa-main-w', Math.round(w) + 'px');
    }

    function updateGalleryChrome(instantDots) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-qa-thumb]'), function (btn, i) {
        btn.classList.toggle('is-active', i === currentSlide);
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-qa-dot]'), function (btn, i) {
        btn.classList.toggle('is-active', i === currentSlide);
      });
      syncDotsProgress(currentSlide, !!instantDots);
      scrollActiveThumbIntoView();
      updateThumbsNav();
    }

    function destroyGallerySwiper() {
      if (!gallerySwiper) return;
      try {
        gallerySwiper.destroy(true, true);
      } catch (e) {
        /* ignore */
      }
      gallerySwiper = null;
    }

    function getViewportWidth() {
      if (!viewport) return 0;
      return viewport.clientWidth || viewport.offsetWidth || 0;
    }

    function sizeGallerySlides() {
      if (!track || !viewport) return;
      var w = getViewportWidth();
      if (!w) return;
      Array.prototype.forEach.call(track.children, function (slide) {
        slide.style.flex = '0 0 ' + w + 'px';
        slide.style.width = w + 'px';
        slide.style.minWidth = w + 'px';
        slide.style.maxWidth = w + 'px';
      });
    }

    function syncSlideFromScroll() {
      if (galleryScrollLock) return;
      var w = getViewportWidth();
      if (!w || !viewport) return;
      var next = Math.round(viewport.scrollLeft / w);
      next = Math.max(0, Math.min((visibleMedia.length || 1) - 1, next));
      if (next === currentSlide) {
        syncDotsProgress(viewport.scrollLeft / w, true);
        return;
      }
      currentSlide = next;
      updateGalleryChrome(true);
    }

    function bindNativeGallerySwipe() {
      if (!viewport || viewport.getAttribute('data-qa-scroll-bound') === 'true') return;
      viewport.setAttribute('data-qa-scroll-bound', 'true');
      var scrollTick = null;
      viewport.addEventListener(
        'scroll',
        function () {
          var w = getViewportWidth() || 1;
          syncDotsProgress(viewport.scrollLeft / w, true);
          if (scrollTick) cancelAnimationFrame(scrollTick);
          scrollTick = requestAnimationFrame(syncSlideFromScroll);
        },
        { passive: true }
      );
      viewport.addEventListener('scrollend', syncSlideFromScroll, { passive: true });
      window.addEventListener('resize', function () {
        var keep = currentSlide;
        sizeGallerySlides();
        if (viewport) viewport.scrollLeft = keep * getViewportWidth();
      });
      bindDesktopGalleryDrag();
    }

    /* Mouse / trackpad drag — overflow scroll alone does not swipe on desktop. */
    function bindDesktopGalleryDrag() {
      var dragRoot = main || viewport;
      if (!dragRoot || !viewport || dragRoot.getAttribute('data-qa-drag-bound') === 'true') return;
      dragRoot.setAttribute('data-qa-drag-bound', 'true');

      var dragging = false;
      var moved = false;
      var startX = 0;
      var startScroll = 0;
      var startSlide = 0;

      function onMove(event) {
        if (!dragging) return;
        var dx = event.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        viewport.scrollLeft = startScroll - dx;
        if (moved) {
          event.preventDefault();
        }
      }

      function endDrag(clientX) {
        if (!dragging) return;
        dragging = false;
        window.removeEventListener('pointermove', onMove, true);
        window.removeEventListener('pointerup', onUp, true);
        window.removeEventListener('pointercancel', onUp, true);
        viewport.classList.remove('is-dragging');
        if (main) main.classList.remove('is-dragging');
        viewport.style.scrollSnapType = '';
        viewport.style.scrollBehavior = '';

        var w = getViewportWidth() || 1;
        var dx = clientX - startX;
        var target = Math.round(viewport.scrollLeft / w);
        if (moved && Math.abs(dx) > Math.max(40, w * 0.12)) {
          target = dx < 0 ? startSlide + 1 : startSlide - 1;
        }
        target = Math.max(0, Math.min((visibleMedia.length || 1) - 1, target));
        showSlide(target);
      }

      function onUp(event) {
        endDrag(event.clientX);
      }

      dragRoot.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch') return;
        if (event.button != null && event.button !== 0) return;
        if (event.target && event.target.closest && event.target.closest('.quick-add-modal__nav-btn, .quick-add-modal__thumb, .quick-add-modal__dot')) {
          return;
        }
        dragging = true;
        moved = false;
        startX = event.clientX;
        startScroll = viewport.scrollLeft;
        startSlide = Math.round(startScroll / (getViewportWidth() || 1));
        viewport.style.scrollSnapType = 'none';
        viewport.style.scrollBehavior = 'auto';
        viewport.classList.add('is-dragging');
        if (main) main.classList.add('is-dragging');
        window.addEventListener('pointermove', onMove, true);
        window.addEventListener('pointerup', onUp, true);
        window.addEventListener('pointercancel', onUp, true);
        event.preventDefault();
      });
    }

    function renderGallery(variant) {
      visibleMedia = galleryMediaForVariant(variant);
      /* alt-gallery + color-coded: packshot/featured already at 0; else scroll to featured */
      currentSlide =
        data.useAltGalleryTag || data.hasColorCoded || data.hasColorCodedAlts
          ? 0
          : featuredMediaIndex(variant, visibleMedia);
      galleryFeaturedTarget = currentSlide;
      galleryGoToken += 1;
      galleryScrollLock = true;
      destroyGallerySwiper();

      if (track) {
        track.innerHTML = '';
        visibleMedia.forEach(function (media, index) {
          var slide = document.createElement('div');
          slide.className = 'quick-add-modal__slide';
          slide.setAttribute('data-slide', String(index));
          var img = document.createElement('img');
          img.src = media.src;
          img.alt = media.alt || data.title || '';
          img.draggable = false;
          img.loading = index === currentSlide ? 'eager' : 'lazy';
          if (index === currentSlide) {
            var applyMainWidth = function () {
              syncMainWidthFromImage();
              sizeGallerySlides();
              goToFeaturedSlide(0);
            };
            img.addEventListener('load', applyMainWidth);
            if (img.complete) applyMainWidth();
          }
          slide.appendChild(img);
          track.appendChild(slide);
        });
      }

      if (viewport) {
        viewport.classList.remove('swiper', 'swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden');
        viewport.style.scrollBehavior = 'auto';
        /* Keep scroll locked at featured target — never park on slide 0 then jump */
        var seedW = getViewportWidth();
        viewport.scrollLeft = seedW ? galleryFeaturedTarget * seedW : 0;
      }
      if (track) {
        track.classList.remove('swiper-wrapper');
        track.removeAttribute('style');
        track.removeAttribute('id');
      }

      if (thumbs) {
        thumbs.innerHTML = '';
        visibleMedia.forEach(function (media, index) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'quick-add-modal__thumb' + (index === currentSlide ? ' is-active' : '');
          btn.setAttribute('data-qa-thumb', String(index));
          btn.setAttribute('aria-label', 'View image ' + (index + 1));
          var img = document.createElement('img');
          img.src = media.srcThumb || media.src;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 97;
          img.height = 142;
          btn.appendChild(img);
          btn.addEventListener('click', function (event) {
            event.preventDefault();
            showSlide(index);
          });
          thumbs.appendChild(btn);
        });
        thumbs.scrollTop = 0;
      }

      if (dots) {
        dots.innerHTML = '';
        dots.style.setProperty('--qa-dot-count', String(Math.max(visibleMedia.length, 1)));
        dots.style.setProperty('--qa-dot-progress', String(currentSlide));
        if (visibleMedia.length > 1) {
          var indicator = document.createElement('span');
          indicator.className = 'quick-add-modal__dots-indicator';
          indicator.setAttribute('aria-hidden', 'true');
          dots.appendChild(indicator);
          visibleMedia.forEach(function (_media, index) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'quick-add-modal__dot' + (index === currentSlide ? ' is-active' : '');
            btn.setAttribute('data-qa-dot', String(index));
            btn.setAttribute('aria-label', 'View image ' + (index + 1));
            btn.addEventListener('click', function (event) {
              event.preventDefault();
              showSlide(index);
            });
            dots.appendChild(btn);
          });
        }
      }

      if (nav) {
        nav.hidden = visibleMedia.length < 2;
      }

      bindNativeGallerySwipe();
      syncMainWidthFromImage();
      sizeGallerySlides();
      requestAnimationFrame(function () {
        syncMainWidthFromImage();
        goToFeaturedSlide(0);
      });
    }

    function syncDotsProgress(progress, instant) {
      if (!dots) return;
      var count = visibleMedia.length || 1;
      var max = Math.max(count - 1, 0);
      var next = Math.max(0, Math.min(max, progress));
      var indicator = dots.querySelector('.quick-add-modal__dots-indicator');
      if (instant && indicator) {
        indicator.classList.add('is-instant');
      }
      dots.style.setProperty('--qa-dot-progress', String(next));
      if (instant && indicator) {
        void indicator.offsetWidth;
        indicator.classList.remove('is-instant');
      }
    }

    function showSlide(index) {
      if (!visibleMedia.length) return;
      currentSlide = ((index % visibleMedia.length) + visibleMedia.length) % visibleMedia.length;
      if (viewport) {
        var w = getViewportWidth();
        viewport.scrollTo({
          left: currentSlide * w,
          behavior: 'smooth'
        });
      }
      updateGalleryChrome(false);
    }

    function selectSwatch(position, value, swatchBtn) {
      selected[position] = value || '';
      Array.prototype.forEach.call(
        root.querySelectorAll('[data-qa-swatch][data-option-position="' + position + '"]'),
        function (btn) {
          var on =
            btn === swatchBtn ||
            optionsMatch(btn.getAttribute('data-option-value') || btn.getAttribute('data-color'), selected[position]);
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
      );
      updateOptionNameLabels();
      if (hasButtonOptions) {
        renderButtonOptions();
      } else {
        applyVariant(resolveVariant(selected));
      }
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var pos = Number(btn.getAttribute('data-option-position')) || data.colorOptionPosition;
        var value = btn.getAttribute('data-option-value') || btn.getAttribute('data-color') || '';
        selectSwatch(pos, value, btn);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        showSlide(currentSlide - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        showSlide(currentSlide + 1);
      });
    }

    if (thumbsPrevBtn) {
      thumbsPrevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        scrollThumbsBy(-1);
      });
    }

    if (thumbsNextBtn) {
      thumbsNextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        scrollThumbsBy(1);
      });
    }

    if (thumbs) {
      thumbs.addEventListener(
        'scroll',
        function () {
          updateThumbsNav();
        },
        { passive: true }
      );
    }

    if (typeof ResizeObserver !== 'undefined' && thumbsWrap) {
      var thumbsResizeObserver = new ResizeObserver(function () {
        updateThumbsNav();
      });
      thumbsResizeObserver.observe(thumbsWrap);
      if (main) thumbsResizeObserver.observe(main);
    }

    window.addEventListener('resize', updateThumbsNav);

    // Gallery swipe is handled by Swiper (initGallerySwiper) for smooth finger tracking.

    // Boot — seed selected from default variant / first values, then render.
    var defaultVariant = findVariantById(data.defaultVariantId) || data.variants[0];
    if (defaultVariant) {
      optionMetas.forEach(function (meta) {
        if (!selected[meta.position]) {
          selected[meta.position] = optionValue(defaultVariant, meta.position) || '';
        }
      });
    }

    swatches.forEach(function (btn) {
      var pos = Number(btn.getAttribute('data-option-position'));
      var value = btn.getAttribute('data-option-value') || btn.getAttribute('data-color') || '';
      var on = optionsMatch(value, selected[pos]);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    updateOptionNameLabels();

    if (hasButtonOptions) {
      renderButtonOptions();
    } else {
      applyVariant(resolveVariant(selected));
    }
  }

  window.initQuickAddModals = function (root) {
    var scope = root || document;
    // Fetched / lifted modals pass the modal element itself as root.
    // querySelectorAll only matches descendants, so init the root when it is a modal.
    if (scope.matches && scope.matches('[data-quick-add-modal]')) {
      initModal(scope);
    }
    scope.querySelectorAll('[data-quick-add-modal]').forEach(initModal);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.initQuickAddModals(document);
    });
  } else {
    window.initQuickAddModals(document);
  }
})();

